module.exports = __webpack_public_path__ + "media/images/vp/icon.vote.smile-1-c5ca9457aac921e59c66eac6cd432dd8.svg";